import axios from 'axios'
export default async function GetAllCategories() {
  const {data} = await axios.get(
    process.env.NEXT_PUBLIC_API_URL + '/categories/get-all-categories',
  )
  return data
}
